import type { JoinTransformer } from "@/types/workspace";
import type { JoinColumnItem } from "@/types/workspace/Transformer";
import { Select, TagsInput } from "@mantine/core";
import { useState } from "react";
import { TransformerBase } from "./TransformerBase";

export function TransformerJoin({
  data,
  warning,
  error,
  onUpdate,
}: {
  data: JoinTransformer;
  warning?: string;
  error?: string;
  onUpdate?: (updatedData: JoinTransformer) => void;
}) {
  const [source, setSource] = useState(data.source || "");
  const [joinType, setJoinType] = useState(data.join_type || "");
  const [dbTableId, setDbTableId] = useState(data.db_table_id || "");
  const [newColumnList, setNewColumnList] = useState(
    data.new_column_list || []
  );
  const [joinColumnList, setJoinColumnList] = useState(
    data.join_column_list || []
  );

  const handleSourceChange = (value: string | null) => {
    if (value !== null) {
      setSource(value);
      if (onUpdate) {
        onUpdate({ ...data, source: value });
      }
    }
  };

  const handleJoinTypeChange = (value: string | null) => {
    if (value !== null) {
      setJoinType(value);
      if (onUpdate) {
        onUpdate({ ...data, join_type: value });
      }
    }
  };

  const handleDbTableIdChange = (value: string | null) => {
    if (value !== null) {
      setDbTableId(value);
      if (onUpdate) {
        onUpdate({ ...data, db_table_id: value });
      }
    }
  };

  const handleNewColumnListChange = (value: string[]) => {
    setNewColumnList(value);
    if (onUpdate) {
      onUpdate({ ...data, new_column_list: value });
    }
  };

  const handleJoinColumnListChange = (value: JoinColumnItem[]) => {
    setJoinColumnList(value);
    if (onUpdate) {
      onUpdate({ ...data, join_column_list: value });
    }
  };

  return (
    <TransformerBase warning={warning} error={error}>
      <Select
        variant="light"
        bdrs="sm"
        bg="#F1F3F4"
        placeholder="Source"
        data={["source_1", "source_2", "source_3"]}
        value={source}
        onChange={handleSourceChange}
      />
      <Select
        variant="light"
        bdrs="sm"
        bg="#F1F3F4"
        placeholder="Join Type"
        data={["inner", "left", "right", "full"]}
        value={joinType}
        onChange={handleJoinTypeChange}
      />
      <Select
        variant="light"
        bdrs="sm"
        bg="#F1F3F4"
        placeholder="DB Table ID"
        data={["db_table_1", "db_table_2", "db_table_3"]}
        value={dbTableId}
        onChange={handleDbTableIdChange}
      />
      <TagsInput
        variant="light"
        bdrs="sm"
        bg="#F1F3F4"
        placeholder="New Column List"
        data={["column_1", "column_2", "column_3"]}
        value={newColumnList}
        onChange={handleNewColumnListChange}
      />
      <TagsInput
        variant="light"
        bdrs="sm"
        bg="#F1F3F4"
        placeholder="Join Column List"
        data={["column_1", "column_2", "column_3"]}
        value={joinColumnList.map((item: JoinColumnItem) => item.old_column)}
        onChange={(value: string[]) =>
          handleJoinColumnListChange(
            value.map(
              (item) =>
                ({
                  old_column: item,
                  new_column: item,
                  operator: "eq",
                } as JoinColumnItem)
            )
          )
        }
      />
    </TransformerBase>
  );
}
